import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchSearchPage, SEARCH_MIN_LENGTH, type SearchParams } from './search-api';

/** Quiet time after the last keystroke before a search starts. */
export const SEARCH_DEBOUNCE_MS = 300;

/** True when `q` is long enough to send (spec 110 §6: a shorter query shows the hint, no request). */
export const isSearchable = (q: string) => q.trim().length >= SEARCH_MIN_LENGTH;

/** Cursor-paged results of one query with its filters; idle while the query is too short. */
export function useSearchQuery(params: SearchParams) {
  const q = params.q.trim().replace(/\s+/g, ' ');
  return useInfiniteQuery({
    queryKey: ['search', q, [...params.types].sort(), params.includeArchived] as const,
    queryFn: ({ pageParam }) => fetchSearchPage({ ...params, q }, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    enabled: isSearchable(q),
    retry: false,
    staleTime: 30_000,
  });
}
